
<div class="lgs-status lm-border bg-white">
    <div class="lgs-status-button">
        <c-toolbar-button
            icon    = "mdi-router-wireless"
            size    = "20"
            color   = "primary"
            :tooltip = "$t('lgsmart.refresh')"
           @click   = "load"
        />
    </div>

    <div v-if="!liftBox" class="label">
        {{ $t('lgsmart.noData') }}
    </div>

    <div v-for="(device, index) in devices" :key="device.key" :class="{'mt-4': index > 0}">
        <v-row no-gutters>
            <v-col class="v-col-6 bold">
                {{ $t('lgsmart.sensor.' + device.key + '.name') }}
            </v-col>
            <v-col class="v-col-6 eid">
                {{ device.eid ? device.eid : '---' }}
            </v-col>
        </v-row>

        <template v-if="device.eid">
            <v-row no-gutters v-if="device.firmware">
                <v-col class="v-col-6 label">
                    {{ $t('lgsmart.firmware') }}
                </v-col>
                <v-col class="value">
                    {{ device.firmware }}
                </v-col>
            </v-row>

            <v-row no-gutters v-if="device.pairTime">
                <v-col class="v-col-6 label">
                    {{ $t('lgsmart.pairTime') }}
                </v-col>
                <v-col class="value">
                    {{ toDateString (device.pairTime) }}
                </v-col>
            </v-row>

            <v-row no-gutters v-if="liftboxState">
                <v-col class="v-col-6 label">
                    Status
                </v-col>
                <v-col class="value">
                    <div v-if="device.states.length === 0" class="success--text">
                        {{ $t('lgsmart.state.ok') }}
                    </div>
                    <div v-for="item in device.states" :key="item.state" class="error--text">
                        {{ $t('lgsmart.state.' + item.state) }}
                        <span v-if="item.since">{{ $t('lgsmart.since') }} {{ toDateString (item.since) }}</span>
                    </div>
                </v-col>
            </v-row>
        </template>
    </div>
</div>
